import { createFileRoute, useParams } from "@tanstack/react-router";
import { FixedLayout } from "@/components/shared/fixed-layout";
import { useTerm } from "@/lib/api/terms/hooks";
import { useLoadingIndicator } from "@/lib/hooks/use-loading-indicator";
import { LoadingSkeleton } from "@/components/shared/loading-skeleton";
import { DocViewer } from "@growing/editor";
import "@growing/editor/styles.css";

function TermPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const { data: term, isLoading } = useTerm(id);

  useLoadingIndicator(isLoading);

  if (!term && !isLoading) {
    return (
      <FixedLayout headerType="back" title="약관" showButton={false}>
        <div className="size-full flex flex-col items-center justify-center text-muted-foreground">
          약관을 찾을 수 없습니다.
        </div>
      </FixedLayout>
    );
  }

  return (
    <FixedLayout
      headerType="back"
      title={term?.title || "약관"}
      showButton={false}
    >
      <LoadingSkeleton className="w-full h-96" isLoading={isLoading}>
        <DocViewer value={term?.doc} />
      </LoadingSkeleton>
    </FixedLayout>
  );
}

export const Route = createFileRoute("/term/$id")({
  component: TermPage,
});
